import React, {useContext, useEffect, useState} from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow} from '@mui/material';
import Moment from 'react-moment';
import {researchApi} from '../../../services/ResearchServices';
import {DispatchContext} from '../../../store';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import DeleteResearchDialog from './ResearchPopup';

export default function ResearchList(props) {
  const dispatch = useContext(DispatchContext);
  const [researchMaterial, setResearchMaterial] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [meta, setMeta] = useState({total: 0});
  const [open, setOpen] = useState(false);
  const [researchId, setResearchId] = useState(null);

  useEffect(() => {
    fetchMaterials();
  },[page, rowsPerPage]);

  const fetchMaterials = () => {
    researchApi('get', null, {page: page,  per_page: rowsPerPage}).then(res => {
      setResearchMaterial(res?.data);
      setMeta(res?.meta);
    })
  }

  const deleteResearchMaterial = (id) => {
    setResearchId(id);
    setOpen(true);
  }

  const handleChangePage = (event, newPage) => {
    dispatch({type: 'IS_NOT_LOADING', payload: false});
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  }

  const handleAction = () => {
    setOpen(false);
    setResearchId(null);
  }

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell sx={{color: '#B3B3B3', width: 20}}>Sl.No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Title</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Description</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Site URL</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Created Date</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {researchMaterial?.length > 0 && researchMaterial?.map((material, index) => (
              <TableRow key={index} hover>
                <TableCell>
                  {index + 1}.
                </TableCell>
                <TableCell align="left" className={'text-capitalize'}>{material?.title}</TableCell>
                <TableCell align="left">{material?.description || '-'}</TableCell>
                <TableCell align="left">
                  <a href={material?.site_url} target={'_blank'}>
                    {material?.site_url || '-'}
                  </a>
                </TableCell>
                <TableCell align="left"><Moment format={'ll'}>{material?.created_at || '-'}</Moment></TableCell>
                <TableCell align="left">
                  <IconButton onClick={() => deleteResearchMaterial(material?.id)}>
                    <DeleteIcon sx={{color: '#ff5959'}}/>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <DeleteResearchDialog open={open} handleAction={handleAction} researchId={researchId} researchMaterial={researchMaterial}
                            setResearchMaterial={setResearchMaterial}/>
    </div>
  );
}